import styled from "styled-components";
import { Modal } from "components/Modal";

export const PrepareUnsubscribeStrategyModalContainer = styled(Modal)`
  text-align: center;

  .modal-content {
    padding-bottom: 18px;
  }

  h3 {
    margin: 12px 0 30px;
    font-weight: 700;
    font-size: 23px;
    color: ${({ theme }) => theme.heading.color.secondary};
  }

  .description {
    font-weight: 500;
    font-size: 15px;
    color: ${({ theme }) => theme.global.extraInfo.font.color};
  }

  .reasons {
    text-align: left;
    margin: 0 30px 30px;

    .form-check .form-check-input {
      background-color: transparent;
      border: 1px solid #838383;
      border-radius: 3px;
      cursor: pointer;
    }

    .form-check label {
      font-weight: 400;
      font-size: 13px;
      color: ${({ theme }) => theme.global.extraInfo.font.color};
    }
  }

  .details {
    font-weight: 500;
    font-size: 12px;
    color: #838383;
  }

  .button-wrapper {
    margin: 0 3rem;

    .btn-no,
    .btn-yes {
      width: 100%;
      margin-top: 16px;
    }

    .btn-no {
      border: 1px solid ${({ theme }) => theme.global.color.quinary};
      background-color: transparent;
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
      color: ${({ theme }) => theme.button.font.secondary};
    }

    .btn-yes {
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
    }
  }
`;
